import type { Component } from "vue";

export interface PropertyRenderer {
  twinTypePattern: string;
  customId: string;
  viewComponentTable?: Component;
  viewComponentDetail?: Component;
  editComponent?: Component;
}

const registry: PropertyRenderer[] = [];

function patternToRegex(pattern: string): RegExp {
  const escaped = pattern
    .replace(/[.+^${}()|[\]\\]/g, "\\$&")
    .replace(/\*/g, ".*");
  return new RegExp(`^${escaped}$`);
}

export function register(renderer: PropertyRenderer): void {
  const alreadyExists = registry.some(
    (r) =>
      r.twinTypePattern === renderer.twinTypePattern &&
      r.customId === renderer.customId,
  );
  if (alreadyExists) return;
  registry.push(renderer);
}

export function getRenderer(
  twinType: string | undefined,
  customId: string | undefined,
): PropertyRenderer | undefined {
  if (!twinType || !customId) return undefined;
  return registry.find(
    (r) =>
      r.customId === customId &&
      patternToRegex(r.twinTypePattern).test(twinType),
  );
}
